import { Directive, HostListener, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[disableDoubleClick]',
})
export class DisableDoubleClickDirective {
  @Input() disableTime = 1500;
  private isDisabled = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    if (this.isDisabled) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }

    this.isDisabled = true;

    this.renderer.setProperty(this.el.nativeElement, 'disabled', true);

    setTimeout(() => {
      this.isDisabled = false;
      this.renderer.setProperty(this.el.nativeElement, 'disabled', false);
    }, this.disableTime);
  }
}
